import React, {Component} from "react"
import {Button, Col, Glyph, Row, Table} from "elemental"
import {Link} from "react-router"
import Price from "../../components/Price/Price"
import shop from "../../shop/shop"
import {checkCartSize, checkMinCartValue} from "./check"
import "./CheckoutPage.scss"

const PositionRow = ({position}) => {
  return (
    <tr>
      <td>{position.article_nr}</td>
      <td>{position.desc}</td>
      <td className="tc">{position.count * position.unit_multi} {translate("product.piece")}</td>
      <td className="tr"><Price>{position.price}</Price></td>
      <td className="tr"><Price>{position.sum}</Price></td>
    </tr>
  )
}

export default class SuccessPage extends Component {

  state = {
    bill: false
  }

  componentDidMount() {

    let ok = checkCartSize()
    ok     = ok && checkMinCartValue()
    if (!ok) return

    shop.cart.submit({
      extras: {
        delivery_address_id: shop.cart.data.deliveraddress.mapid,
        manual_order_id:     false
      }
    }).then((bill) => {
      this.setState({bill})
      shop.cart.productsById.clear()
      shop.cart.update()
    })
      .catch(error => {
        console.error("Checkout Error:", error)
        this.setState({error})
      })
  }

  render() {
    const {bill} = this.state
    return <Page bill={bill}/>
  }
}

const Page = ({bill}) => {
  if (!bill) return null

  const order = bill
  let billingAddress = null
  let hasSession = !!shop.hasSession()

  if (hasSession) {
    let session = shop.hasSession();
    billingAddress = session.value;
  }

  if(!billingAddress) billingAddress = {}

  return (
    <div className="container billing pt4">
      <section className="billing-tab">
        <img className="pt2 pb4" src="/logo.png" alt="MAGS"/>
        <h1 className="tl ttu b pb2">Bestellbestätigung</h1>
        <h2 className="intro-line">Vielen Dank für Ihre Bestellung!</h2>
        <p>Ihre Bestellung ist bei uns eingegangen und wird schnellstmöglich bearbeitet. Die Auftragsbestätigung mit allen relevanten Daten wird Ihnen in Kürze übermittelt.</p>
        <p>
          Sollten Sie zu Ihrer Bestellung noch Fragen haben, kontaktieren Sie uns unter:<br/>
          E-Mail: <a href="mailto:vertrieb@mags-vertrieb.de">vertrieb@mags-vertrieb.de</a><br/>
          Tel.: <a href="tel:+497033466680">07033 46668-0</a>
        </p>
      </section>

      <section className="billing-tab">
        <h2>Ihre Daten</h2>
        <Table className="billing-overview-table">
          <colgroup>
            <col width="25%"/>
            <col width="75%"/>
          </colgroup>

          <tbody>
          {order.manual_order_id && <tr>
            <td>Ihre Bezeichnung</td>
            <td className="overview-value">{order.manual_order_id}</td>
          </tr>}
          <tr>
            <td>Auftrags-Nr.</td>
            <td className="overview-value">{order.handid}</td>
          </tr>

          <tr>
            <td>Bestelldatum</td>
            <td className="overview-value">{new Date(order.created).toLocaleDateString()}</td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>

          <tr>
            <td>Kundennummer</td>
            <td className="overview-value">{order.customerid}</td>
          </tr>

          <tr>
            <td>E-Mail</td>
            <td className="overview-value">{order.customer.email}</td>
          </tr>

          <tr>
            <td>Telefon</td>
            <td className="overview-value">{order.customer.phone}</td>
          </tr>
          </tbody>
        </Table>
      </section>

      <section className="billing-tab">
        <Row>
          <Col sm="1/2">
            <h4>{translate("address.invoice")}</h4>
            <p>
              {billingAddress.title} <br />
              {billingAddress.street} <br />
              {billingAddress.pcode} {billingAddress.city}<br />
              {billingAddress.country}
            </p>
          </Col>

          <Col sm="1/2">
            <h4>{translate("address.delivery_address")}</h4>
            <p>
              {order.deliver.company} <br/>
              {order.deliver.name1} {order.deliver.name2} {order.deliver.name3} <br/>
              {order.deliver.street} <br/>
              {order.deliver.addition} <br/>
              {order.deliver.pcode} {order.deliver.city} <br/>
              {order.deliver.country}
            </p>
          </Col>
        </Row>
      </section>

      <section className="billing-tab">
        <h2>Ihre Bestellung</h2>
        <PositionsTable positions={order.positions} netto={order.netto} currency={order.currency}/>

        <h3 className="mt4">Zahlungsweise</h3>
        <p>{order.customer.extras.zahlung}</p>

        <h3 className="mt4">Ihre Mitteilung</h3>
        <p>{order.comment}</p>

        <div className="mt4">
          <p className="b"><i className="icon-info-circled"></i> Bitte nehmen Sie keine Zahlungen anhand der
                                                                 Bestellbestätigung vor!</p>
          <p>Der Gesamtpreis netto kann sich durch ggf. zu berechnende Mehrwertsteuer, Versand- und Verpackungskosten,
             zurzeit nicht oder nicht mehr verfügbare Artikel, noch ändern</p>
        </div>
      </section>

      <section className="text-left">
        <Link to="/"> <Button type="primary"> <Glyph icon="triangle-left"/> zurück zum Shop </Button> </Link>
      </section>
      <br/>
    </div>
  )
}

const PositionsTable = ({positions, netto}) => {
  return (
    <Table>
      <colgroup>
        <col width="10%"/>
        <col width="45%"/>
        <col width="15%"/>
        <col width="15%"/>
        <col width="15%"/>
      </colgroup>

      <tbody>
      <tr>
        <th>{translate("product.articlenr")}</th>
        <th>{translate("product.label")}</th>
        <th className="tc">{translate("product.articlenr")}</th>
        <th className="tr">{translate("product.single_price")}</th>
        <th className="tr">{translate("product.sum")}</th>
      </tr>

      {positions.map((position) => <PositionRow key={position.article_id} position={position}/>)}

      <tr>
        <td className="netto-sum tr" colSpan="5">Gesamtpreis netto: {netto} €</td>
      </tr>
      </tbody>
    </Table>
  )
}



// WEBPACK FOOTER //
// ./src/pages/checkout/SuccessPage.js